const routes = {
  // Root
  root: '/',
  cdmx: '/cdmx',
  queretaro: '/queretaro',
  puebla: '/puebla',
  leon: '/leon',
  barrioadentro: '/barrioadentro',
  repositorio: '/repositorio',
  contacto: '/contacto',
};

export default routes;
